import { jsx as _jsx } from "react/jsx-runtime";
import { Grid } from "../../grid";
import { BlockField } from "../";
export const BlockColumn = ({ children, columns, columnEnd, columnStart, onCatch, }) => (_jsx(Grid, { columns: columns, columnStart: columnStart, columnEnd: columnEnd, children: children.map(block => (_jsx(BlockField, { block: block, onCatch: onCatch }, block.id))) }));
BlockColumn.defaultProps = {
    columns: 2,
};
